import { render, staticRenderFns } from "./ImportWells.vue?vue&type=template&id=5909ae82"
import script from "./ImportWells.vue?vue&type=script&lang=js"
export * from "./ImportWells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports